<template>
    <div class="flex flex-col justify-center items-center h-full">
      <!-- Form Section -->
      <div class="flex flex-col justify-center items-center w-full p-4 bg-white rounded-lg border-2 border-black shadow-lg">
        <form v-if="!success" @submit.prevent="submitForm" class="flex flex-col space-y-4 w-full">
          <!-- Email Input -->
          <div>
            <label for="email" class="block text-sm font-medium">Email Address:</label>
            <input 
              type="email" 
              id="email" 
              v-model="email" 
              placeholder="Enter your email" 
              class="border border-gray-300 rounded w-full py-2 px-3 text-sm"
            />
            <!-- Error Message -->
            <span v-if="emailError" class="text-red-600 text-sm">{{ emailError }}</span>
          </div>
  
          <!-- Checkbox for Sign Up Confirmation -->
          <div>
            <label class="inline-flex items-center">
              <input 
                type="checkbox" 
                v-model="agreeToSignUp" 
                required 
                class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
              />
              <span class="ml-2">I want to be notified of updates.</span>
            </label>
          </div>
  
          <!-- Submit Button -->
          <div>
            <button 
              type="submit" 
              class="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded w-full"
            >
              Sign Up
            </button>
          </div>
        </form>
  
        <!-- Success Message -->
        <div v-if="success" class="text-center">
          <p>Thank you for signing up! You will be notified of updates soon.</p>
        </div>
      </div>
    </div>
</template>
  
  
<script>
  export default {
    data() {
      return {
        email: "", // Email input state
        agreeToSignUp: false, // Checkbox state
        emailError: null, // Error message for email validation
        success: false, // Success state after submitting
      };
    },
    methods: {
      // Basic email validation using regex
      validateEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      },
      async sendToMongoDB(email) {
        try {
            const response = await fetch(`${process.env.VUE_APP_NODE_SERVER_BASE_URL}/signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
            });

            if (response.status === 201) {
            return { success: true };
            } else if (response.status === 409) {
            this.emailError = "This email is already registered.";
            return { success: false };
            } else {
            this.emailError = "An unexpected error occurred. Please try again.";
            return { success: false };
            }
        } catch (error) {
            console.error("Error submitting email:", error);
            this.emailError = "There was an error submitting the form. Please try again.";
            return { success: false };
        }
    },
    async submitForm() {
        this.emailError = null; // Reset error message

        // Validate email
        if (!this.validateEmail(this.email)) {
            this.emailError = "Please use a valid email address";
            return;
        }

        if (!this.agreeToSignUp) {
            this.emailError = "Please agree to be notified of updates.";
            return;
        }

        try {
            // Attempt to send data to MongoDB
            const response = await this.sendToMongoDB(this.email);

            if (response.success) {
            // If successful, show success message
            this.success = true;
            } else if (this.emailError) {
            // Email error has already been set, do nothing here
            return;
            } else {
            // Handle generic submission failure
            this.emailError = "There was an issue signing you up. Please try again.";
            }

        } catch (error) {
            console.error("Error submitting the form:", error);
            this.emailError = "There was an error. Please try again.";
        }
    }
    },
  };
</script>
  